import React from "react";
import { RouteComponentProps, Route, withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { AppSelectorListContainer } from "../..";
import AppSettings from "./AppSettings";
import { appPaths } from "../../../Common";

type TParams = {
  id: string;
};

type State = {
  defaultAppId: string;
  appId: string;
};

class ApplicationAdminContainer extends React.Component<RouteComponentProps<TParams>, State> {
  constructor(props: RouteComponentProps<TParams>) {
    super(props);

    this.state = {
      defaultAppId: this.props.match.params.id,
      appId: this.props.match.params.id
    };

    this.onSelectedAppChange = this.onSelectedAppChange.bind(this);
  }

  componentDidUpdate() {
    if (this.props.match.params.id !== this.state.defaultAppId) {
      // default changed
      this.setState((prevState: State) => {
        return {
          ...prevState,
          defaultAppId: this.props.match.params.id,
          appId: this.props.match.params.id
        };
      });
    }
  }

  onSelectedAppChange(selectedAppId: string) {
    this.props.history.push(appPaths.app.admin.replace(":id", selectedAppId));
    // this.setState((prevState: State) => {
    //   return {
    //     ...prevState,
    //     appId: selectedAppId
    //   };
    // });
  }

  render() {
    return (
      <>
        <h2>Application Administration</h2>
        <br />
        <Row>
          <Col sm={2}>
            <AppSelectorListContainer
              defaultSelectedAppId={this.props.match.params.id}
              onSelectedAppChange={this.onSelectedAppChange}
            />
          </Col>
          <Col lg={10}>
            <AppSettings selectedAppId={this.state.appId} />
          </Col>
        </Row>
      </>
    );
  }
}

export default withRouter(ApplicationAdminContainer);
